import React from 'react';
import HeroSection2 from "~/src/uiblocks/landing/HeroSection2";
import type { MetaFunction } from "@remix-run/node";
import WhoIsWayPickForSection from "~/src/uiblocks/landing/WhoIsWayPickForSection";
import KeyFeatures from "~/src/uiblocks/landing/KeyFeatures";
import ReadyExploreSmart from "~/src/uiblocks/landing/ReadyExploreSmart";
import GoogleSearch from "~/src/uiblocks/landing/GoogleSearch";

export const meta: MetaFunction = () => {
  return [
    { title: "Discover attractions near you - WayPick" },
    {
      name: "description",
      content: "WayPick builds smart, personalized routes for your day. Let AI do the planning - so you can focus on the experience."
    },
  ];
};

function LandingPage() {
  return (
    <>
      <HeroSection2 />

      <GoogleSearch/>
      <WhoIsWayPickForSection />
      <KeyFeatures />
      <ReadyExploreSmart />



      <section className="bg-white py-12 px-4 sm:px-6 lg:px-8">
        {/*  <div className="max-w-4xl mx-auto text-center">*/}
        {/*  </div>*/}
      </section>
    </>
  );
}

export default LandingPage;